module.exports = __webpack_public_path__ + "img/aq.0c586e7b.png";